
/**
 * Converts a UTC date string to IST formatted string.
 * Uses `toLocaleString` with 'Asia/Kolkata' timezone.
 * @param {string} utcDateString
 * @returns {string} Formatted IST string or fallback
 */
export const formatInIST = (utcDateString) => {
    const date = new Date(utcDateString);
    if (isNaN(date)) return utcDateString;
    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };
